<ng-container *ngFor="let bound of this.boundList; index as boundIndex">
  <div class="p-input-list-area01">
    <div class="p-input-list-area01__item">
      <div class="p-input-list-area01__block">
        <div class="p-input-list-area01__block-item">
          <div class="p-input-list-area01__heading">
            <h3
              class="p-input-list-area01__heading-title"
              [innerHTML]="'label.number.section.n' | staticMsg : { '0': boundIndex + 1 }"
            ></h3>
            <div *ngIf="boundIndex !== 0" class="p-input-list-area01__heading-sub-function">
              <button
                id="{{ 'oneway-or-multicity-delete-button-' + boundIndex }}"
                type="button"
                class="c-btn-fluctuation c-btn-fluctuation--remove"
                (click)="clickDeleteBoundButton(boundIndex)"
              >
                <span
                  class="u-visually-hidden"
                  [innerHTML]="'reader.deleteBound' | staticMsg : { '0': boundIndex + 1 }"
                ></span
                ><span aria-hidden="true" [innerHTML]="'label.deleteBound' | staticMsg"></span>
              </button>
            </div>
          </div>
          <asw-airport-round [switchBtnHidden]="true">
            <asw-airport
              #originAirportComponent
              id="airport-from-{{ boundIndex }}"
              origin
              label="Departure"
              [boundIndex]="boundIndex"
              [airportListParts]="bound.airportListPartsFrom ?? airportListPartsFrom"
              [airportFormControl]="bound.originLocationFormControl"
              (changeEvent)="getOutputOriginAirport($event, boundIndex)"
            ></asw-airport>
            <asw-airport
              #destinationAirportComponent
              id="airport-to-{{ boundIndex }}"
              destination
              label="Arrival"
              [boundIndex]="boundIndex"
              [airportListParts]="bound.airportListPartsTo ?? airportListPartsTo"
              [airportFormControl]="bound.destinationLocationFormControl"
              (changeEvent)="getOutputDestinationAirport($event, boundIndex)"
            ></asw-airport>
          </asw-airport-round>
        </div>
      </div>
    </div>

    <div class="p-input-list-area01__item">
      <div class="p-input-list-area01__block p-input-list-area01__block--half">
        <div class="p-input-list-area01__block-item">
          <div class="p-input-list-area01__block-item-box">
            <asw-date-selector
              #departureDateComponent
              [dateSelectorParts]="bound.dateSelectorParts ?? dateSelectorParts"
              (changeDate)="getOutputDepartureDate($event, boundIndex)"
              [dateForm]="bound.departureDateFormControl"
            >
            </asw-date-selector>
          </div>
        </div>

        <div class="p-input-list-area01__block-item">
          <h4 class="p-input-list-area01__block-item-lv2title" [innerHTML]="'labal.departureTime' | staticMsg"></h4>
          <asw-range-slider
            type="time"
            ariaLabel="labal.departureTime"
            handlePoint="two"
            [valueMin]="this.TIME_WINDOW_MIN"
            [valueMax]="this.TIME_WINDOW_MAX"
            [stepGrid]="this.TIME_WINDOW_STEP"
            [disabled]="oldDomesticAswSearchFlag"
            unitFront=""
            unitBack=""
            [formControl]="bound.departureTimeWindow"
          ></asw-range-slider>
        </div>
      </div>
    </div>
  </div>

  <div class="p-input-list-area01">
    <div class="p-input-list-area01__item">
      <div class="p-input-list-area01__block">
        <div class="p-input-list-area01__block-item">
          <div class="p-input-list-area01__block-item-link--right">
            <button
              id="{{ 'oneway-or-multicity-add-button-' + boundIndex }}"
              type="button"
              class="c-btn-fluctuation c-btn-fluctuation--add"
              [ngClass]="{ 'is-disabled': this.boundList.length === this.MAX_BOUND_LIST_LENGTH }"
              [disabled]="this.boundList.length === this.MAX_BOUND_LIST_LENGTH"
              (click)="clickAddBoundButton(boundIndex + 1)"
              *ngIf="boundIndex < this.MAX_BOUND_LIST_LENGTH - 1"
            >
              <span
                class="u-visually-hidden"
                [innerHTML]="'reader.addBound' | staticMsg : { '0': boundIndex + 1 }"
              ></span
              ><span aria-hidden="true" [innerHTML]="'label.addBound' | staticMsg"></span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- [3段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block">
      <div class="p-input-list-area01__block-item">
        <div class="c-form-element-checkbox">
          <div class="c-form-element-checkbox__wrap">
            <asw-checkbox
              label="{{ 'label.searchFlightFlexibleDate' | staticMsg }}"
              [formControl]="formControlCompareFaresNearbyDates"
              [disabled]="this.boundInputCount < 2 || (this.isJapanOnlyFlag && this.boundInputCount < 3)"
              (change$)="getOutputCompareFaresNearbyDate($event)"
              id="oneway-or-multicity-checkbox-1"
            ></asw-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- //[3段目] -->

<!-- [4段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block p-input-list-area01__block--half">
      <div class="p-input-list-area01__block-item">
        <asw-passenger-selector
          [passengersCount]="this.passengersCount"
          [passengersErrorMsg]="this.information.passengersErrorMsg"
          [isEnabled]="this.isEnabled"
          [isInfantCountShow]="
            !this.isJapanOnlyFlag || this.posCountryCode === 'JP' || dcsMigrationDateStatus !== 'Before'
          "
          [isChild3To11]="this.isJapanOnlyFlag && this.posCountryCode !== 'JP' && dcsMigrationDateStatus === 'Before'"
          [isInfant0To1]="!oldDomesticAswSearchFlag"
          [dcsMigrationDateStatus]="dcsMigrationDateStatus"
          (apply$)="getOutputPassengerSelect($event)"
        ></asw-passenger-selector>
      </div>
    </div>
  </div>
</div>
<!-- //[4段目] -->

<!-- [5段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block">
      <div class="p-input-list-area01__block-item">
        <asw-toggle
          id="oneway-or-multicity-toggle"
          [checked]="this.formControlMixedCabinSwitch.value!"
          text="{{ 'label.differentClass' | staticMsg }}"
          altMessage="{{ 'label.differentClass' | staticMsg }}"
          (changeEvent)="this.getOutputMixedCabinSwitch()"
          [isEnable]="this.boundInputCount === 2 && (!this.isJapanOnlyFlag || this.dcsMigrationDateStatus !== 'Before')"
        ></asw-toggle>
      </div>
    </div>
  </div>
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block p-input-list-area01__block--half">
      <div class="p-input-list-area01__block-item">
        <div class="c-form-element-select is-selected">
          <div class="c-form-element-select__wrap">
            <label for="oneway-or-multicity-select-1" class="c-form-element-select__label"
              ><span
                class="c-form-element-select__label-text"
                [innerHTML]="
                  (this.formControlMixedCabinSwitch.value ? 'label.DepartureClass' : 'label.selectClass') | staticMsg
                "
              ></span
            ></label>
            <select
              class="c-form-element-select__select"
              id="oneway-or-multicity-select-1"
              name="oneway-or-multicity-select-1"
              aria-invalid="false"
              (change)="getOutputCabinClass($event)"
            >
              <option
                *ngFor="let option of this.cabinClassOptions"
                value="{{ option.value }}"
                [selected]="option.value === selectedCabinClass"
              >
                {{ option.textContent }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="p-input-list-area01__block-item">
        <ng-container *ngIf="this.formControlMixedCabinSwitch.value">
          <div class="c-form-element-select is-selected">
            <div class="c-form-element-select__wrap">
              <label for="oneway-or-multicity-select-2" class="c-form-element-select__label"
                ><span class="c-form-element-select__label-text" [innerHTML]="'label.ReturnClass' | staticMsg"></span
              ></label>
              <select
                class="c-form-element-select__select"
                id="oneway-or-multicity-select-2"
                name="oneway-or-multicity-select-2"
                aria-invalid="false"
                (change)="getOutputReturnCabinClass($event)"
              >
                <option
                  *ngFor="let option of this.cabinClassOptions"
                  value="{{ option.value }}"
                  [selected]="option.value === selectedReturnCabinClass"
                >
                  {{ option.textContent }}
                </option>
              </select>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="!this.formControlMixedCabinSwitch.value && this.isFareTypeShow">
          <asw-fare-type-selector
            [selected]="this.selectedFareOptionType"
            [selectedCabinClass]="this.selectedCabinClass"
            [isEnabled]="this.isEnabled"
            [isJapanOnlyFlag]="this.isJapanOnlyFlag"
            (apply$)="getOutputFareOptionType($event)"
          >
          </asw-fare-type-selector>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- //[5段目] -->

<!-- [6段目] -->
<div class="p-input-list-area01">
  <div class="p-input-list-area01__item">
    <div class="p-input-list-area01__block p-input-list-area01__block--half">
      <div class="p-input-list-area01__block-item">
        <ng-container *ngIf="this.isOnlyPromotionCodeAvailable">
          <asw-input
            label="{{ 'label.promotionCode1' | staticMsg }}"
            placeholder="{{ 'placeholder.promotionCode' | staticMsg }}"
            type="text"
            [formControl]="formControlPromotionCode"
            (change$)="getOutputPromotionCode($event)"
            id="oneway-or-multicity-input-1"
            [disabled]="oldDomesticAswSearchFlag"
            maxlength="15"
          ></asw-input>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- //[6段目] -->
